import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';
import InstagramIcon from '@mui/icons-material/Instagram';
import TwitterIcon from '@mui/icons-material/Twitter';
import YouTubeIcon from '@mui/icons-material/YouTube';

// リンク情報
const pages = [{ name: '設計屋の作業部屋', link: 'https://sekkeiyanosagyoubeya.com/' }];
const snsLinks = [
  { name: 'Instagram', icon: <InstagramIcon />, link: 'https://www.instagram.com/sekkei_ya/' },
  { name: 'X', icon: <TwitterIcon />, link: 'https://x.com/_sekkeiya' },
  { name: 'YouTube', icon: <YouTubeIcon />, link: 'https://www.youtube.com/@sekkeiya' }
];

function ResponsiveAppBar() {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar position="static" sx={{ padding: 0, margin: 0 }}>
      <Container maxWidth="xl">
        <Toolbar disableGutters>

          {/* メニュー（モバイルと同じ表示） */}
          <Box sx={{ display: { xs: 'flex', md: 'flex' }, alignItems: 'center' }}>
            <IconButton
              size="large"
              aria-label="メニューを開く"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
              sx={{ mr: 2 }}
            >
              <MenuIcon />
            </IconButton>

            {/* モバイルメニュー */}
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'left' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'block' } }}
            >
              {pages.map((page) => (
                <MenuItem key={page.name} onClick={handleCloseNavMenu}>
                  <Typography
                    component="a"
                    href={page.link}
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={{ textAlign: 'center', color: 'inherit', textDecoration: 'none' }}
                  >
                    {page.name}
                  </Typography>
                </MenuItem>
              ))}
            </Menu>
          </Box>

          {/* タイトル中央配置 */}
          <Box sx={{ flexGrow: 1, display: 'flex', justifyContent: 'center' }}>
            <Typography
              variant="h6"
              noWrap
              component="a"
              href="/"
              sx={{
                fontFamily: 'monospace',
                fontWeight: 700,
                letterSpacing: '.3rem',
                color: 'inherit',
                textDecoration: 'none',
              }}
            >
              Resize Textures
            </Typography>
          </Box>

          {/* SNSアイコンを右端に配置 */}
          <Box sx={{ display: 'flex', gap: 2 }}>
            {snsLinks.map((sns) => (
              <IconButton
                key={sns.name}
                href={sns.link}
                target="_blank"
                rel="noopener noreferrer"
                color="inherit"
              >
                {sns.icon}
              </IconButton>
            ))}
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default ResponsiveAppBar;
